export default __webpack_public_path__ + "assets/images/928f26a8634702401f1bb75485b0bc5a.png";